<template>
  <div
    class="card-padding d-flex flex-column flex-md-row justify-content-between align-items-center"
  >
    <div>
      <span> Total {{ totalCount }} entries </span>
    </div>
    <div class="d-flex flex-column flex-md-row align-items-center">
      <div
        class="per-page-width d-flex align-items-center mr-md-1 mt-1 mt-md-0"
      >
        <span class="mr-1">Showing</span>
        <atom-select
          v-model="currentPerPage"
          placeholder="Per Page"
          :option="perPageOption"
          :isClearable="false"
          @change="onChangePerPage"
        ></atom-select>
      </div>
      <div class="mt-1 mt-md-0">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="perPage"
          size="sm"
          class="my-0"
          @change="onChangeCurrentPage"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { BPagination } from "bootstrap-vue"
import AtomSelect from "../atoms/AtomSelect.vue"
export default {
  name: "MoleculePaginationWithPerPage",
  components: { AtomSelect, BPagination },
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  emits: ["onUpdatePaginationOrPerPage"],
  data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      perPageOption: [5, 10, 30, 50],
    }
  },

  watch: {
    page: {
      immediate: true,
      handler() {
        this.currentPage = this.page
      },
    },
    perPage: {
      immediate: true,
      handler() {
        this.currentPerPage = this.perPage
      },
    },
  },

  methods: {
    onChangeCurrentPage(currentPage) {
      this.$emit("onUpdatePaginationOrPerPage", this.perPage, currentPage)
    },

    onChangePerPage(currentPerPage) {
      this.$emit("onUpdatePaginationOrPerPage", currentPerPage, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-width {
  width: 160px;
}
</style>
